import { v4 as uuidv4 } from 'uuid';
import { innovorderApi } from '../index';
import { ApiRequest, ApiResponse } from '../providers/innovorder.types';
import { OrderCreated, OrderToCreate, OrderToVerify, OrderVerified } from './order.type';

const brandApi = innovorderApi.injectEndpoints({
    endpoints: (build) => ({
        previewOrder: build.mutation<OrderVerified, ApiRequest<OrderToVerify>>({
            query: (body) => ({
                url: `/orders/preview`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [],
            transformResponse: (response: ApiResponse<OrderVerified>) => ({
                restaurantId: response.data.restaurantId,
                channelId: response.data.channelId,
                consumptionMode: response.data.consumptionMode,
                menuId: response.data.menuId,
                cart: response.data.cart,
                promocode: response.data.promocode,
                comment: response.data.comment,
                recap: response.data.recap,
            }),
            extraOptions: { maxRetries: 3 },
        }),
        createOrder: build.mutation<OrderCreated, ApiRequest<OrderToCreate>>({
            query: (body) => ({
                url: `/orders`,
                method: 'POST',
                body,
                headers: {
                    'idempotency-key': uuidv4(),
                },
            }),
            invalidatesTags: [],
            transformResponse: (response: ApiResponse<OrderCreated>) => response.data,
            extraOptions: { maxRetries: 3 },
        }),
    }),
});

export const { usePreviewOrderMutation, useCreateOrderMutation } = brandApi;
